@if (hasEntitlements) {
  <div class="mat-typography mat-body mat-app-background main">
    <div>
      <h2>Find a Member</h2>
    </div>
    <div class="search-section">
      <div class="combined-section">
        <div class="label">Search by:</div>
        <div class="radio-section">
          <!-- FORM -->
          <form [formGroup]="searchForm" class='email-form' (submit)="submit(searchForm)">
            <mat-radio-group formControlName="searchType" (change)="searchTypeChange($event.value)" class="phaltu"
              aria-label="Select an option">
              <!-- MEMBER ID / UMI-->
              <div class="radio-text">
                <mat-radio-button value="memberIDOrUMI" class="radio-label">Member ID or UMI</mat-radio-button>
                <div class="text-button"
                  [ngClass]="{'hide' : hideMemberIDOrUMI && hideMemberIDOrUMI.toString() === 'true'?true:false}">
                  <input type="text" class="text-input" maxlength="12" formControlName="memberIDOrUMI" matInput />
                  <button type="submit" mat-raised-button color="primary" mat-button
                  [disabled]="!searchForm?.get('memberIDOrUMI').valid" class="primary-btn search">Search</button>
                </div>
                <div class="error"
                  [ngClass]="{'hide' : hideMemberIDOrUMI && hideMemberIDOrUMI.toString() === 'true'?true:false}">
                  @if (searchForm.controls['memberIDOrUMI'].errors?.pattern) {
                    <mat-error>Please enter only the numeric
                    part of the Member ID/UMI.</mat-error>
                  }
                </div>
              </div>
              <!-- AGREEMENT # -->
              <div class="radio-text">
                <mat-radio-button value="agreementNumber" class="radio-label">Agreement Number</mat-radio-button>
                <div class="text-button"
                  [ngClass]="{'hide' : hideAgreementNumber && hideAgreementNumber.toString() === 'true'?true:false}">
                  <input type="text" class="text-input" maxlength="10" formControlName="agreementNumber" matInput />
                  <button type="submit" mat-raised-button color="primary" mat-button
                  [disabled]="!searchForm?.get('agreementNumber').valid" class="primary-btn search">Search</button>
                </div>
                <div class="error"
                  [ngClass]="{'hide' : hideAgreementNumber && hideAgreementNumber.toString() === 'true'?true:false}">
                  @if (searchForm.controls['agreementNumber'].errors?.pattern) {
                    <mat-error>Please enter valid agreement
                    number.</mat-error>
                  }
                </div>
              </div>
              <!-- SSN -->
              <div class="radio-text">
                <mat-radio-button value="ssn" class="radio-label">Social Security Number</mat-radio-button>
                <div class="text-button" [ngClass]="{'hide' : hideSSN && hideSSN.toString() === 'true'?true:false}">
                  <input type="text" class="text-input" type='password' maxlength="9" formControlName="ssn" matInput />
                  <button type="submit" mat-raised-button color="primary" mat-button
                  [disabled]="!searchForm?.get('ssn').valid" class="primary-btn search">Search</button>
                </div>
                <div class="error" [ngClass]="{'hide' : hideSSN && hideSSN.toString() === 'true'?true:false}">
                  @if (searchForm.controls['ssn'].errors?.pattern) {
                    <mat-error>Please enter valid SSN.</mat-error>
                  }
                </div>
              </div>
            </mat-radio-group>
          </form>
        </div>
      </div>
    </div>
    @for (memberData of memberResponse?.payload?.results; track memberData) {
      <div>
        <app-member-card
          [memberData]="memberData"
          [retentionId]="memberResponse.payload.retentionId"
          [healthSherpaRegionConfig]="healthSherpaRegionConfig"
          [enrollPageUrl]="enrollPageUrl"
          [buttonContentSubmitAsHealthSherpa]="buttonContentSubmitAsHealthSherpa"
        [buttonContentSubmitAsShopX]="buttonContentSubmitAsShopX"></app-member-card>
      </div>
    }
  </div>
} @else {
  <div class="loading-container warning-message">
    {{ noEntitlementsMessage || 'Your currently do not have access to view Find Current Members. Try a
    different agency if available.'}}
  </div>
}
